import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation, UseMutationResult } from "@tanstack/react-query"
import { AxiosResponse } from "axios"

type UseBlobsProps = {
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

type MutationProps = {
  file: File
  filename: string
}

export type UseBlobs = (props?: UseBlobsProps) => UseMutationResult<AxiosResponse<any, any>, any, MutationProps, unknown>

const useBlobs: UseBlobs = ({ onSuccess, onError }: UseBlobsProps = { }) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['blobs'],
    mutationFn: async ({ file, filename }: MutationProps) => {
      return await privateAxios.postForm('/blobs', {
        blob: {
          io: file,
          filename,
        }
      })
    },
    onSuccess,
    onError,
  })
}

export default useBlobs